import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import Main from "./layout/Main";

import { useAuthContext } from "../context/AuthContext";


const PrivateRoute = ({ children }) => {
  const { userProfile ,logout } = useAuthContext();
  const [isAuthenticated, setIsAuthenticated] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setIsAuthenticated(false);
    }

   
    const handleStorageChange = () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setIsAuthenticated(false);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  if (!isAuthenticated) {
    logout()
    return <Navigate to="/login" />;
  }

  return <><Main>{children}</Main></> // Allow access to children if authenticated
};

export default PrivateRoute;
